import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/reducers";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false // ← ezt kapcsolod ki
    })
});

export default store;
